<template>
  <v-card v-if="loading" class="control-card preload-box h-100 pa-2 " style="min-height: 380px;">
    <v-progress-circular indeterminate color="primary" class="h-100"></v-progress-circular>
  </v-card>
  <div v-else class="control-block control-block--reverse">
    <v-layout d-flex column style="gap: 16px;">
      <v-card class="control-card" style="gap: 16px;">
        <div class="control-card__part">
          <p class="control-card__title">Сборы</p>
          <span>За текущие сутки</span>
        </div>
        <v-layout d-flex column style="gap: 8px;">
          <v-layout row align-center style="line-height: 1;">
            <div class="mr-2 font-weight-bold" style="flex: 1;">
              <p class="ma-0 mb-1">Кол-во рейсов ВСЕГО</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(allFlights, allFlights) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ allFlights }}</div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <div class="mr-2 font-weight-bold" style="flex: 1;">
              <p class="ma-0 mb-1">С открытыми актами</p>
              <span class="d-block blue" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(acts.open_acts, allFlights) }"></span>
            </div>
            <div class="font-weight-bold blue--text" style="font-size: 20px;">{{ acts.open_acts || '-' }}</div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <div class="mr-2 font-weight-bold" style="flex: 1;">
              <p class="ma-0 mb-1">С закрытыми актами</p>
              <span class="d-block green" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(acts.close_acts, allFlights) }"></span>
            </div>
            <div class="font-weight-bold green--text" style="font-size: 20px;">{{ acts.close_acts || '-' }}</div>
          </v-layout>
        </v-layout>
      </v-card>
    </v-layout>
    <v-card class="control-card">
      <p class="control-card__title">Контроль досмотра пассажиров и багажа</p>
      <span>За текущие сутки</span>
      <v-layout d-flex wrap mt-2 style="gap: 24px;">
        <v-layout d-flex column justify-space-between style="gap: 16px; min-width: 170px;">
          <h2 class="control-card__title">Пассажиры</h2>
          <v-layout row align-center style="line-height: 1; height: 35px;">
            <img src="/static/img/control/register.svg">
            <div class="mx-2 font-weight-bold" style="flex: 1;">
              <p class=" ma-0 mb-1">Регистрация</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(passengers.checkin_pax, maxPassengers) }"></span>
              <!-- <span class="mt-1 d-block blue" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(passengers.checkin_paxonline, maxPassengers) }"></span>
              <p class="ma-0 mt-1 blue--text">онлайн</p> -->
            </div>
            <div style="text-align: right;">
              <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ passengers.checkin_pax || '-' }}
              </div>
              <!-- <div class="font-weight-bold blue--text" style="font-size: 16px;">{{ passengers.checkin_paxonline || '-'
                }}
              </div> -->
            </div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <img src="/static/img/control/security.svg">
            <div class="mx-2 font-weight-bold" style="flex: 1;">
              <p class=" ma-0 mb-1">Досмотр</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(passengers.security_pax, maxPassengers) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ passengers.security_pax || '-' }}</div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <img src="/static/img/control/onboard.svg">
            <div class="mx-2 font-weight-bold" style="flex: 1;">
              <p class=" ma-0 mb-1">Посадка</p>
              <span class="d-block green" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(passengers.boarding_pax, maxPassengers) }"></span>
            </div>
            <div class="font-weight-bold green--text" style="font-size: 20px;">{{ passengers.boarding_pax || '-' }}
            </div>
          </v-layout>
        </v-layout>
        <v-layout d-flex column justify-space-between style="gap: 16px; min-width: 170px;">
          <h2 class="control-card__title">Багаж</h2>
          <v-layout row align-center style="line-height: 1;">
            <img src="/static/img/control/reg_bag.svg">
            <div class="mx-2 font-weight-bold" style="flex: 1;">
              <p class=" ma-0 mb-1">Регистрация</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(passengers.checkin_bags, maxLuggage) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ passengers.checkin_bags || '-' }}</div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <img src="/static/img/control/sec_bag.svg">
            <div class="mx-2 font-weight-bold" style="flex: 1;">
              <p class=" ma-0 mb-1">Досмотр</p>
              <span class="d-block grey" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(passengers.security_bags, maxLuggage) }"></span>
            </div>
            <div class="font-weight-bold grey--text" style="font-size: 20px;">{{ passengers.security_bags || '-' }}
            </div>
          </v-layout>
          <v-layout row align-center style="line-height: 1;">
            <img src="/static/img/control/borad_bag.svg">
            <div class="mx-2 font-weight-bold" style="flex: 1;">
              <p class=" ma-0 mb-1">Погрузка</p>
              <span class="d-block green" style="height: 6px; border-radius: 5px;"
                :style="{ width: getWidth(passengers.loading_bags, maxLuggage) }"></span>
            </div>
            <div class="font-weight-bold green--text" style="font-size: 20px;">{{ passengers.loading_bags || '-' }}
            </div>
          </v-layout>
        </v-layout>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import store from '@/store'
export default {
  props: ['loading'],
  components: {},
  computed: {
    controlsData() {
      return store.getters['controls/getControls']
    },
    acts() {
      return this.controlsData.acts || {}
    },
    allFlights() {
      const flights = this.controlsData.flights
      return (flights.flights_arrival || 0) + (flights.flights_departure || 0)
    },
    passengers() {
      return this.controlsData.passengers || {}
    },
    maxPassengers() {
      const data = [this.passengers.checkin_pax, this.passengers.checkin_paxonline, this.passengers.security_pax, this.passengers.boarding_pax]
      return Math.max(...Object.values(data))
    },
    maxLuggage() {
      const data = [this.passengers.checkin_bags, this.passengers.security_bags, this.passengers.loading_bags]
      return Math.max(...Object.values(data))
    },
  },
  methods: {
    getWidth(value, maxValue) {
      if (maxValue === 0) return '100%';
      if (value >= maxValue) return '100%';
      const percentage = (value / maxValue) * 100;
      return `${percentage}%`;
    }
  }
}
</script>
